import { b as __spreadArray, _ as __assign } from './_tslib-ff3a08af.js';

var baseUiInitialState = {
    loadedDetailsId: null,
    loadedIds: []
};
var baseUiReducers = {
    setIds: function (state, _a) {
        var ids = _a.payload.ids;
        state.loadedIds = ids;
    },
    upsertIds: function (state, _a) {
        var ids = _a.payload.ids;
        state.loadedIds = Array.from(new Set(__spreadArray(__spreadArray([], state.loadedIds, true), ids, true)));
    },
    setDetails: function (state, _a) {
        var id = _a.payload.id;
        state.loadedDetailsId = id;
    }
};

var initialLoadingState = {
    loadingPending: 0,
    error: null
};
var isLoadingSelector = function (state) {
    return state.loadingPending > 0;
};
var errorSelector = function (state) {
    return state.error;
};
var getEntityAdapterReducers = function (adapter) {
    return {
        addOne: adapter.addOne,
        removeOne: adapter.removeOne,
        updateOne: adapter.updateOne,
        upsertOne: adapter.updateOne,
        addMany: adapter.addMany,
        removeMany: adapter.removeMany,
        updateMany: adapter.updateMany,
        upsertMany: adapter.upsertMany,
        removeAll: adapter.removeAll,
        setAll: adapter.setAll
    };
};
var getBaseState = function (adapter, additionalState) {
    return __assign(__assign({}, adapter.getInitialState()), additionalState);
};

var handleLoadingAction = function (thunk, builder) {
    if (!thunk) return;
    builder.addCase(thunk.pending, function (state) {
        state.loadingPending = Math.max(1, state.loadingPending + 1) || 1;
    });
    builder.addCase(thunk.rejected, function (state, _a) {
        var _b;
        var error = _a.error;
        state.error = error;
        state.loadingPending = (_b = Math.max(0, state.loadingPending - 1)) !== null && _b !== void 0 ? _b : 0;
    });
};
var handleMultipleLoadingActions = function (thunks, builder) {
    if (!thunks) return;
    thunks.forEach(function (thunk) {
        handleLoadingAction(thunk, builder);
    });
};
var handleFulfilledAction = function (thunk, builder, handler) {
    if (!thunk) return;
    builder.addCase(thunk.fulfilled, function (state, _a) {
        var _b;
        var payload = _a.payload;
        state.loadingPending = (_b = Math.max(0, state.loadingPending - 1)) !== null && _b !== void 0 ? _b : 0;
        handler(state, payload);
    });
};

export { baseUiReducers as a, baseUiInitialState as b, isLoadingSelector as c, getBaseState as d, errorSelector as e, handleMultipleLoadingActions as f, getEntityAdapterReducers as g, handleLoadingAction as h, initialLoadingState as i, handleFulfilledAction as j };
